import React from "react";

/**
 * LogoMark — the chosen emblem: rounded-square outline opening on the
 * right (bracket-C), flat stroke terminals, no dot. Matches the approved
 * "mono emblem + CRYPT.PE" lockup.
 */
export function LogoMark({ size = 22, className = "", color = "#FFFFFF", animated = false }) {
  return (
    <svg
      width={size}
      height={size * (120 / 100)}
      viewBox="0 0 192 232"
      className={className}
      role="img"
      aria-label="crypt.pe"
      style={{ display: "block" }}
    >
      <path
        d="M 146 100 L 146 90 A 34 34 0 0 0 112 56 L 80 56 A 34 34 0 0 0 46 90 L 46 142 A 34 34 0 0 0 80 176 L 112 176 A 34 34 0 0 0 146 142 L 146 132"
        fill="none"
        stroke={color}
        strokeWidth="24"
        strokeLinecap="butt"
        className={animated ? "logo-ring-anim" : ""}
      />
    </svg>
  );
}

/**
 * Logo — emblem + "CRYPT.PE" bold uppercase wordmark (approved lockup).
 */
export function Logo({ className = "", size = "md", theme = "dark", accent, withMark = false }) {
  const sizeClass = {
    sm: "text-[13px]",
    md: "text-[17px]",
    lg: "text-[21px]",
    xl: "text-3xl md:text-4xl",
  }[size] || "text-[17px]";

  const markSize = { sm: 15, md: 19, lg: 24, xl: 40 }[size] || 19;
  const color = theme === "light" ? "#09090b" : "#ffffff";

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} aria-label="crypt.pe">
      {withMark && <LogoMark size={markSize} color={color} className="shrink-0" />}
      <span
        className={`font-black uppercase tracking-[0.08em] ${sizeClass}`}
        style={{ fontFamily: "'Satoshi', 'Inter', system-ui, sans-serif", color }}
      >
        CRYPT.PE
      </span>
    </span>
  );
}

export default Logo;
